import React from 'react';
import Typography from '@mui/material/Typography';
import { getFormattedPaycodeDuration } from '../Calendar/calendarFunctions';
import { getPaycodeTimePeriod } from '../Utils/uiGenerators';
import { styles } from './paycodeCard.service';

const noop = () => { };

const PaycodeCard = ({
    handleOnClick = noop,
    paycode,
}) => {
    const {
        durationInTime,
        payCodeRef: { qualifier },
        assignmentName,
    } = paycode;

    const timeRange = getPaycodeTimePeriod(paycode);
    const formattedDuration = getFormattedPaycodeDuration(durationInTime);

    return (
        <div
            style={styles.paycodeCard}
            onClick={handleOnClick}
        >
            <div style={styles.cardTypeContainer}>
                <div style={styles.cardType}>
                    {`${qualifier} [${formattedDuration}]`}
                </div>
            </div>
            <Typography variant={'subtitle1'}>
                {timeRange}
            </Typography>
            {assignmentName && (
                <Typography variant={'subtitle2'}>
                    {`Assignment: ${assignmentName}`}
                </Typography>
            )}
        </div>
    );
}

export default PaycodeCard;
